import { fetchWithAuth, getCSRFToken } from '../auth';

const API_HOST = process.env.REACT_APP_ICC_TOOL_API_HOST;

const readOpts = () => ({
    headers: { 'X-CSRFToken': getCSRFToken() },
    credentials: 'include',
});

const buildQuery = (params) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') qs.set(k, v);
    });
    return qs;
};

function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = Object.assign(document.createElement('a'), { href: url, download: filename });
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

export async function getPlanningReport(params = {}) {
    const resp = await fetchWithAuth(
        `${API_HOST}readiness/future/?${buildQuery(params)}`,
        readOpts()
    );

    if (!resp.ok) {
        if (resp.status === 403) throw new Error('You do not have permission to access the Future Readiness Planning Report.');
        const body = await resp.json().catch(() => ({}));
        throw new Error(body.detail || body.non_field_errors?.[0] || 'Failed to fetch planning report.');
    }

    return resp.json();
}

export async function exportPlanningReport(params = {}) {
    const resp = await fetchWithAuth(
        `${API_HOST}readiness/future/export/?${buildQuery(params)}`,
        readOpts()
    );

    if (!resp.ok) {
        const body = await resp.json().catch(() => ({}));
        throw new Error(body.detail || 'Failed to export planning report.');
    }

    const blob = await resp.blob();
    const start = params.start_date || '';
    const end = params.end_date || '';
    downloadBlob(blob, `future_readiness_${start}_${end}.xlsx`);
}
